namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.resizable()
    @Serenity.Decorators.maximizable()
    export class ApiScriptCodiceDialog extends Serenity.PropertyDialog<any, any> {
        protected getFormKey() { return ApiScriptCodiceForm.formKey; }

        protected form = new ApiScriptCodiceForm(this.idPrefix);

        constructor() {
            super();

            $('<a class="inplace-button inplace-action3"><b><i class="fa fa-magic text-blue"></i></b></a>')
                .attr("title", "Copia nella clipboard")
                .insertAfter(this.form.Codice.element)
                .click(e => {
                    var theElement = this.form.Codice.element;
                    theElement.select();
                    document.execCommand('copy');

                    Q.notifySuccess("Il codice è stato copiato nella clipboard.");
                });
        }

        protected onDialogOpen() {
            super.onDialogOpen();

            this.form.Codice.value = this.Codice;
            this.form.Descrizione.value = this.Descrizione;
        }

        protected getDialogOptions() {
            var opt = super.getDialogOptions();
            opt.title = 'Codice da inserire';
            opt.width = 800;
            return opt;
        }

        protected getDialogButtons() {
            var buttons = super.getDialogButtons();

            // Remove button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "btn-primary"), 1);

            return buttons;
        }

        // //////////////////////
        private _Codice: string;

        public get Codice() {
            return this._Codice;
        }

        public set Codice(value: string) {
            if (this._Codice != value) {
                this._Codice = value;
            }
        }

        private _Descrizione: string;

        public get Descrizione() {
            return this._Descrizione;
        }

        public set Descrizione(value: string) {
            if (this._Descrizione != value) {
                this._Descrizione = value;
            }
        }
    }
}